<template>
	<inertia-head title="Marketing Videos" />
	<div class="bg-primary">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0">
					<h1 class="fw-bold text-white mb-2">Marketing Videos</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm">
						Welcome to TRC Admin Dashboard
					</h2>
				</div>
			</div>
		</div>
	</div>
	<div class="content">
		<div class="text-end mb-4">
			<button @click="viewMarketingVideoContentModal(0,'add')" class="btn btn-alt-primary">
				<i class="fa fa-plus me-1"></i>
				Add Marketing Video
			</button>
		</div>
		<div class="block">
			<div class="block-header">
				<div class="block-title"></div>
				<div class="block-options">
					<div class="input-group">
						<form @submit.prevent="searchRecord">
						<input v-model="search" type="text" id="search" name="search" class="form-control" placeholder="Marketing Video Search">
					</form>
					</div>
				</div>
			</div>
			<div class="block-content block-content-full">
				<div class="table-responsive">
					<table class="table table-borderless table-striped table-vcenter">
						<thead>
							<tr>
								<th>Title</th>
								<th>Description</th>
								<th>Category</th>
								<th>Video ID</th>
								<th>Status</th>
								<th>Date Created</th>
								<th class="text-end">:::</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(video, index) in marketingVideos.data" :key="index">
								<td>{{ video.title }}</td>
								<td>{{ video.description }}</td>
								<td>{{ video.category }}</td>
								<td>{{ video.video_id }}</td>
								<td>{{ video.status_format }}</td>
								<td>{{ video.date_created }}</td>
								<td nowrap="" class="text-end">
									<button @click="viewMarketingVideoContentModal(index,'update')" type="button" class="btn btn-alt-info btn-sm me-1"><i class="fa fa-pencil-alt"></i></button>
									<button @click="confirmDelete(index)" type="button" class="btn btn-alt-danger btn-sm"><i class="fa fa-times"></i></button>
								</td>
							</tr>
							<tr v-if="marketingVideos.data.length <= 0">
								<td colspan="7" class="text-center">
									<p class="mb-0 fw-semibold text-danger">NO MARKETING VIDEO FOUND</p>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<pagination :collections="marketingVideos" />
			</div>
		</div>
		
		<add-update-marketing-video-modal ref="addUpdateMarketingVideoModal"/>


		<modal ref="deleteModal">
		<template #title>DELETE CONFIRMATION</template>
		<template #body>
			<div class="text-center">
                <p class="h6">
                    Are you sure, you want to delete this data?
                </p>
            </div>
		</template>
		<template #footer>
			<button type="button" @click="deleteMarketingVideo()" class="btn btn-alt-primary btn-sm"><i class="fa fa-check-circle"></i> YES</button>
            <button @click="deleteModal.toggleModal" type="button" id="btnDeleteClose" class="btn btn-alt-danger btn-sm"><i class="fa fa-times-circle"></i> NO</button>
		</template>
	</modal>

	</div>
</template>

<script>
import { watch, onMounted, ref, reactive } from 'vue'
import AuthLayout from '../../../Layouts/AuthLayout'
import AddUpdateMarketingVideoModal from '../../../Components/Admin/AffiliateProgram/AddUpdateMarketingVideoModal'
import { createToaster } from '@meforma/vue-toaster';
import { Inertia } from '@inertiajs/inertia'

export default {
	layout: AuthLayout,
	props: {
		marketingVideos : Object,
		api_response 	: Object,
		search			: String
	},
	components:{AddUpdateMarketingVideoModal},
	setup(props) {
		onMounted(() => {
			const pageContainer = document.getElementById('page-container')
			if (pageContainer.classList.contains('sidebar-o-xs'))
				pageContainer.classList.remove('sidebar-o-xs')
		})

		const toast = createToaster();

		const search = ref(props.search??'');
		const action = ref('add');

		const cur_index = ref(null);

		const deleteModal 					= ref(null);
		const addUpdateMarketingVideoModal 	= ref(null);

		const selectedMarketingVideoContent = reactive({});

		const confirmDelete = (_index)=>{
			cur_index.value = _index;
			deleteModal.value.toggleModal();
		}

		const viewMarketingVideoContentModal = (_index,_action)=>{
			
			action.value = _action;
			
			if(_action=='update')
			{
				selectedMarketingVideoContent.id 				= props.marketingVideos.data[_index].id;
				selectedMarketingVideoContent.category 			= props.marketingVideos.data[_index].category;
				selectedMarketingVideoContent.title 			= props.marketingVideos.data[_index].title;
				selectedMarketingVideoContent.description 		= props.marketingVideos.data[_index].description;
				selectedMarketingVideoContent.video_id 			= props.marketingVideos.data[_index].video_id;
				selectedMarketingVideoContent.download_link 	= props.marketingVideos.data[_index].download_link;
				selectedMarketingVideoContent.status 			= props.marketingVideos.data[_index].status;
			}

			addUpdateMarketingVideoModal.value.setMarketingVideoContent(_action,selectedMarketingVideoContent);

			addUpdateMarketingVideoModal.value.toggleModal();

		}

		const deleteMarketingVideo = () => {
			action.value = "delete";
			var id = props.marketingVideos.data[cur_index.value].id;

			Inertia.delete('marketing-video/'+id, {
				preserveState: true,
				preserveScroll: true,
				only:['marketingVideos,api_response','search'],
				onSuccess: () => {
					deleteModal.value.toggleModal();
				},
			})
		}

		const searchRecord = () => {

							Inertia.get(
								route('admin.affiliate-program.marketing-videos'),
								{
									search 		: search.value
								},
								{
									preserveState: true,
									preserveScroll: true,
									only:['marketingVideos,api_response','search'],
								}
							)
						}

		watch(()=>props.api_response, (value) => {
			
			if(value!=null)
			{
				var action_msg = action.value=='add' ? 'added' : (action.value=='delete' ? 'deleted' : 'updated');

				if(value.result=="success")
				{
					toast.show("Successfully "+action_msg, { type: value.result});
				}else
				{
					toast.show("Failed to "+action_msg, { type: "error"});
				}
			}
		})

		return{
			search,
			action,
			cur_index,
			searchRecord,
			confirmDelete,
			deleteModal,
			addUpdateMarketingVideoModal,
			deleteMarketingVideo,
			selectedMarketingVideoContent,
			viewMarketingVideoContentModal
		}
	},
}
</script>
